// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucidePercentSquare as RawLucidePercentSquare } from "lucide-react";
export const LucidePercentSquare = /* @__PURE__ */ createIcon(RawLucidePercentSquare, "LucidePercentSquare", 2);
